import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "table table-hover align-middle" }
const _hoisted_4 = { class: "border-dark border-bottom pb-2" }
const _hoisted_5 = { class: "col-1" }
const _hoisted_6 = { class: "col-1" }
const _hoisted_7 = {
  key: 0,
  class: "col-1"
}
const _hoisted_8 = { class: "ms-2" }
const _hoisted_9 = { class: "ms-2" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "delete", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 0,
  class: "row"
}
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-3" }
const _hoisted_18 = { class: "col-3" }
const _hoisted_19 = { class: "col-6" }
const _hoisted_20 = {
  type: "submit",
  class: "btn btn-primary"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "mas ms-n1 me-1" }, "add", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_input_number = _resolveComponent("input-number")!
  const _component_dp_form = _resolveComponent("dp-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertError2, {
      error: _ctx.pageUI.getError()
    }, null, 8, ["error"]),
    (_ctx.pageUI.getIsReady())
      ? (_openBlock(), _createBlock(_component_dp_form, {
          key: 0,
          as: "form",
          onSubmit: _ctx.addDiscountStep,
          novalidate: ""
        }, {
          default: _withCtx(({ errors }) => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("table", _hoisted_3, [
                  _createElementVNode("thead", _hoisted_4, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t('discountStepFrom')), 1),
                      _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t('discountStepDiscountValue')), 1),
                      (!_ctx.readonly)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_7))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.discountSteps, (stepOverview) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: stepOverview.id
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_8, _toDisplayString(stepOverview.step.quantity_from), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_9, _toDisplayString(stepOverview.discount_value_as_string), 1)
                      ]),
                      (!_ctx.readonly)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_10, [
                            _createElementVNode("div", null, [
                              _createElementVNode("button", {
                                class: "btn btn-icon btn-danger ms-2",
                                onClick: ($event: any) => (_ctx.deleteDiscountStep(stepOverview.id))
                              }, _hoisted_13, 8, _hoisted_11)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ])
            ]),
            (!_ctx.readonly)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_input_number, {
                          modelValue: _ctx.addStepFrom,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.addStepFrom) = $event)),
                          name: _ctx.$t('discountStepFrom'),
                          mode: "group-add-discount-step",
                          step: 1,
                          min: 0,
                          rules: "required",
                          errors: errors
                        }, null, 8, ["modelValue", "name", "errors"])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_input_number, {
                          modelValue: _ctx.addStepDiscountValue,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.addStepDiscountValue) = $event)),
                          name: _ctx.$t('discountStepDiscountValue'),
                          mode: "group-add-discount-step",
                          step: 0.01,
                          min: 0,
                          rules: "required",
                          errors: errors
                        }, null, 8, ["modelValue", "name", "step", "errors"])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("button", _hoisted_20, [
                          _hoisted_21,
                          _createTextVNode(_toDisplayString(_ctx.$t('add')), 1)
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onSubmit"]))
      : _createCommentVNode("", true)
  ], 64))
}